import './DailySyncToggle.scss';
import { AsyncStateAlert } from '@ui/general';
import { AsyncStateNotification } from '@ui/notifications';
import { COPY_SPECIFIC, NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useEffect, useState } from 'react';
import { Row, Switch } from 'antd';
import { useCurrentOrganization, useUpdateOrganization } from '@hooks';

export const DailySyncToggle: React.FC = () => {
	const organization = useCurrentOrganization();
	const { isErrored, isFailed, isSuccessful, request, reset } = useUpdateOrganization();

	const [ toggleClicked, setToggleClicked ] = useState(false);
	const [ enableDailySyncVisible, setEnableDailySyncVisible ] = useState(!organization?.dailySyncEnabled);

	useEffect(() => {
		if (organization?.id && (isErrored || isFailed)) {
			setToggleClicked(false);
			reset();
			request({
				dailySyncEnabled: false,
				organizationId: organization.id
			});
		}
	}, [ organization?.id, isErrored, isFailed, reset, request ]);

	useEffect(() => {
		if (isSuccessful && enableDailySyncVisible) {
			setTimeout(() => setEnableDailySyncVisible(false), 2500);
		}
	}, [ enableDailySyncVisible, isSuccessful ]);

	const handleClick = useCallback(() => {
		if (!organization?.id) {
			return;
		}

		setToggleClicked(true);

		request({
			dailySyncEnabled: true,
			organizationId: organization.id
		});
	}, [ organization?.id, request ]);

	if (!enableDailySyncVisible) {
		return null;
	}

	return (
		<>
			<div id='daily-sync-toggle'>
				<AsyncStateAlert
					received={ NOTIFICATIONS_COPY.SUCCESS_POST_ORGANIZATION }
					stateSelector={ useUpdateOrganization.selectors.state } />

				{ !toggleClicked && COPY_SPECIFIC.DAILY_SYNCS_DISABLED }

				<Row justify='center'>{ !toggleClicked && COPY_SPECIFIC.ACTIVATE_DAILY_SYNCS }</Row>

				<Row justify='center'>
					<Switch
						checked={ toggleClicked }
						checkedChildren='Syncs Enabled!'
						className='enable-daily-sync-toggle'
						disabled={ toggleClicked }
						onClick={ handleClick }
						unCheckedChildren='Syncs Disabled' />
				</Row>
			</div>
			<AsyncStateNotification
				errored={ NOTIFICATIONS_COPY.ERROR_POST_ORGANIZATION }
				failed={ NOTIFICATIONS_COPY.ERROR_POST_ORGANIZATION }
				stateSelector={ useUpdateOrganization.selectors.state } />
		</>
	);
};
